.modal {
  max-width: 600px;
  width: 100%;
}

.header {
  font-size: 18px;
  font-weight: 600;
}

.body {
  padding: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 14px;
    font-weight: 600;

    @include themify($themes) {
      color: themed("main-primary");
    }
  }
}

.error {
  font-size: 13px;
  margin-top: 4px;

  @include themify($themes) {
    color: themed("error-primary");
  }
}

.buttons {
  padding-top: 12px;
}
